/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authOrgsGetQuota } from "../../funcs/authOrgsGetQuota.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetOrgQuotaRequest$inboundSchema,
};

export const tool$authOrgsGetQuota: ToolDefinition<typeof args> = {
  name: "auth-orgs-get-quota",
  description: `Get an org's usage quota`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authOrgsGetQuota(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
